export default __webpack_public_path__ + "static/media/itsalive.acf50e32.svg";